<template>
  <div class="java-class-page">
    <div class="class-content">
      <div class="sidebar-panel">
        <div class="notes">
          <div class="tabs">
            <div :class="tab =='basic'?'tab active':'tab'" @click="switchTab('basic')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
              <span>入门课程</span>
            </div>
            <div :class="tab =='advanced'?'tab active':'tab'" @click="switchTab('advanced')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              <span>进阶课程</span>
            </div>
          </div>
          
          <div class="content-list">
            <div v-for="(c,index) in classes" :key="'basic-'+index" v-if="tab == 'basic'" class="class-section">
              <div @click.stop="openClass(c)" class="class-row">
                <span class="class-name">{{ c.name }}</span>
                <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" v-if="!c.open">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
                <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" v-if="c.open">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
              
              <div v-if="c.open" class="topic-list">
                <div v-for="(s,index1) in c.topic" :key="'basic-'+index+'-'+index1" class="topic-row" @click="loadProject(s)">
                  <span class="topic-number">{{ index1 + 1 }}</span>
                  <span class="topic-name">{{ s.name }}</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="16 18 22 12 16 6"/>
                    <polyline points="8 6 2 12 8 18"/>
                  </svg>
                </div>
              </div>
            </div>

            <div v-for="(c,index) in advanced" :key="'adv-'+index" v-if="tab == 'advanced'" class="class-section">
              <div @click.stop="openClass(c)" class="class-row">
                <span class="class-name">{{ c.name }}</span>
                <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" v-if="!c.open">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
                <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" v-if="c.open">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
              
              <div v-if="c.open" class="topic-list">
                <div v-for="(s,index1) in c.topic" :key="'adv-'+index+'-'+index1" class="topic-row" @click="loadProject(s)">
                  <span class="topic-number">{{ index1 + 1 }}</span>
                  <span class="topic-name">{{ s.name }}</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="16 18 22 12 16 6"/>
                    <polyline points="8 6 2 12 8 18"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="coder-panel">
        <div class="coder-header">
          <div class="header-left">
            <div class="connection-status">
              <div class="status-dot" :class="connected ? 'connected' : 'disconnected'"></div>
              <span>{{ connected ? '已连接' : '未连接' }}</span>
            </div>
          </div>
          
          <div class="header-center">
            <input v-model="stdin" placeholder="输入 stdin 内容..." class="stdin-input"/>
          </div>
          
          <div class="header-right">
            <button @click="saveToFile" class="action-btn save-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                <polyline points="17 21 17 13 7 13 7 21"/>
                <polyline points="7 3 7 8 15 8"/>
              </svg>
              <span>保存</span>
            </button>
          </div>
        </div>
        
        <editor 
          v-model="code" 
          lang="java" 
          theme="chrome" 
          class="editor"
          ref="aceEditor" 
          id="codeEditor"
          :options="editorOptions"
        ></editor>

        <div v-if="result!=null" class="result-panel">
          <div class="result-header">
            <span>运行结果</span>
            <button class="close-btn" @click="result = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div class="result-content" v-html="result"></div>
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <button @click="copyToClipboard" class="btn btn-primary" :disabled="running">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="5 3 19 12 5 21 5 3"/>
        </svg>
        <span>{{ running ? '运行中...' : '运行程序' }}</span>
      </button>
      <button @click="copyToClipboard2" class="btn btn-secondary">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
        </svg>
        <span>复制代码</span>
      </button>
    </div>
  </div>
</template>

<script>
import editor from 'vue2-ace-editor'
import bus from '../utils/bus';
import util from '../utils/util';
require('brace/mode/java');
require('brace/theme/chrome');

export default {
  data() {
    return {
      code: "",
      classes:[],
      advanced:[],
      connected:false,
      running:false,
      result:null,
      stdin:"",
      tab:"basic",
      editorOptions: {
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        enableLinking: false,
        foldStyle: 'manual',
      },
      socket:null,
    };
  },
  components:{
    editor
  },
  mounted() {
    this.loadList();
    this.$nextTick(() => {
      setTimeout(() => {
        const aceInput = document.getElementsByClassName("ace_text-input")[0];
        if (aceInput) {
          aceInput.addEventListener('paste', this.handlePaste);
          aceInput.addEventListener('input', this.handleInput);
        }
      }, 500);
    });
    this.connectLoop();
  },
  methods: {
    handleInput() {
      if(this.socket != null && this.socket.readyState === WebSocket.OPEN) {
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
        try{
          this.socket.send(sendStr);
        }
        catch(err){
          console.log('Send error:', err);
        }
      }
    },
    switchTab(tab){
      this.tab = tab;
    },
    copyToClipboard2(){
      var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = this.code;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
    copyToClipboard() {
      if(this.code == ''){
        return;
      }

      if(this.running){
        return;
      }

      this.running = true;
      this.result = null;

      var postInfo = {};
      postInfo.code = encodeURIComponent(this.code);
      postInfo.language = 8;
      postInfo.stdin = this.stdin;
      postInfo.fileext = "java";

      this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
        console.log(response.data);
        this.running = false;
        this.result = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
      });
    },
    connectLoop(){
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
      else{
        mobile = 's1';
        target = 't1';
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
      }
    },
    handlePaste(){
      if(this.socket != null){
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
          
        }

        if(mobile == null || mobile == ""){
            return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
        try{
          this.socket.send(sendStr);
        }
        catch(err){
          console.log('Paste send error:', err);
        }
      }
    },
    saveToFile() {
      const content = this.code;
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Main.java';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    connectServer(){
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile == null || mobile == ""){
        mobile = 's1';
        target = 't1';
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
      this.socket = socket;

      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
              type:"user",
              mobile:mobile,
              target:target,
              classType:'java',
          }));

        var interval2 = setInterval( ()=>{
          if(this.loopCheck == false){
            clearInterval(interval2);
            this.connected = false;
            this.connectLoop();
            return;
          }
          else{
            socket.send(JSON.stringify(
            {
                type:"loopcheck",
                mobile:mobile
            }))
            this.loopCheck = false;
            console.log('check successful');
          }
        },20000);

        this.connected = true;

        socket.addEventListener('message', event => {
          const reader = new FileReader();
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });
          reader.readAsText(event.data);
        });
      });
    },
    openClass(c){
      c.open = !c.open;
    },
    loadList(){
      var r = new Date().getTime();
      this.$http.get("/data/java/classes.json?random="+r).then(response => {
        this.classes = response.data;
      });
      this.$http.get("/data/java/advanced.json?random="+r).then(response => {
        this.advanced = response.data;
      });
    },
    loadProject(p){
      var r = new Date().getTime();
      this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
        const decoder = new TextDecoder('utf-8');
        const content = decoder.decode(response.data);
        this.code = content;
      }).catch(error => {
        console.log('Load error:', error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.java-class-page {
  position: fixed;
  top: 72px;
  left: 0;
  width: 100%;
  height: calc(100% - 72px);
  background: $bg-secondary;
  display: flex;
  flex-direction: column;
}

.class-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar-panel {
  width: 280px;
  background: white;
  border-right: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  
  @include responsive(md) {
    width: 240px;
  }
}

.notes {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tabs {
  display: flex;
  background: $bg-secondary;
  border-bottom: 1px solid $border-color;
  flex-shrink: 0;
  
  .tab {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 12px 8px;
    font-size: 12px;
    font-weight: 500;
    color: $text-secondary;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all $transition;
    
    svg {
      width: 18px;
      height: 18px;
    }
    
    &:hover {
      color: $primary-color;
      background: rgba($primary-color, 0.05);
    }
    
    &.active {
      color: $primary-color;
      background: white;
      border-bottom-color: $primary-color;
    }
  }
}

.content-list {
  flex: 1;
  overflow-y: auto;
  
  @include scroll-style;
}

.class-section {
  border-bottom: 1px solid $border-color;
}

.class-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 600;
  color: $text-primary;
  cursor: pointer;
  transition: all $transition-fast;
  
  &:hover {
    background: rgba($primary-color, 0.05);
    padding-left: 20px;
  }
  
  .expand-icon {
    width: 16px;
    height: 16px;
    color: $text-muted;
    transition: transform 0.3s ease;
  }
}

.topic-list {
  background: $bg-secondary;
  padding: 4px 0;
}

.topic-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px 10px 24px;
  font-size: 13px;
  color: $text-secondary;
  cursor: pointer;
  transition: all $transition-fast;
  
  &:hover {
    background: white;
    color: $primary-color;
    padding-left: 28px;
    
    svg {
      color: $primary-color;
    }
  }
  
  .topic-number {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    flex-shrink: 0;
  }
  
  .topic-name {
    flex: 1;
  }
  
  svg {
    width: 14px;
    height: 14px;
    color: $text-muted;
    flex-shrink: 0;
  }
}

.coder-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  position: relative;
  overflow: hidden;
}

.coder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid $border-color;
  gap: 16px;
  flex-shrink: 0;
  
  @include responsive(md) {
    flex-wrap: wrap;
    padding: 10px 16px;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: $text-secondary;
  
  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    
    &.connected {
      background: #10b981;
      box-shadow: 0 0 8px rgba(16, 185, 129, 0.5);
    }
    
    &.disconnected {
      background: #ef4444;
      box-shadow: 0 0 8px rgba(239, 68, 68, 0.5);
    }
  }
}

.header-center {
  flex: 1;
  max-width: 400px;
  
  @include responsive(md) {
    order: 3;
    max-width: 100%;
    width: 100%;
  }
}

.stdin-input {
  width: 100%;
  padding: 8px 14px;
  background: $bg-secondary;
  border: 1px solid $border-color;
  border-radius: 8px;
  color: $text-primary;
  font-size: 13px;
  transition: all $transition-fast;
  
  &:focus {
    outline: none;
    border-color: $primary-color;
    box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
  }
  
  &::placeholder {
    color: $text-muted;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all $transition;
  border: none;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  &.save-btn {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    
    &:hover {
      background: rgba($primary-color, 0.15);
    }
  }
}

.editor {
  flex: 1;
  width: 100%;
  background: white !important;
  font-size: 14px !important;
}

.result-panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  border-top: 1px solid $border-color;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: $bg-secondary;
  border-bottom: 1px solid $border-color;
  font-size: 13px;
  font-weight: 600;
  color: $text-primary;
  
  .close-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: $text-muted;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all $transition-fast;
    
    svg {
      width: 16px;
      height: 16px;
    }
    
    &:hover {
      color: $text-primary;
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.result-content {
  flex: 1;
  padding: 12px 16px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: $text-primary;
  line-height: 1.6;
  
  @include scroll-style;
}

.action-buttons {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 12px;
  z-index: 100;
  
  .btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 12px;
    cursor: pointer;
    transition: all $transition;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    
    svg {
      width: 18px;
      height: 18px;
    }
    
    &.btn-primary {
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      color: white;
      
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 30px rgba(99, 102, 241, 0.5);
      }
      
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
    
    &.btn-secondary {
      background: white;
      color: $text-primary;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>

<style lang="scss">
@import '../styles/variables.scss';

.java-class-page {
  .ace_print-margin {
    display: none;
  }
  
  .ace_gutter {
    background: #f8f9fa !important;
    color: $text-muted !important;
  }
  
  .ace_gutter-active-line {
    background: rgba($primary-color, 0.1) !important;
  }
  
  .ace_gutter-cell.error-line {
    background: orangered;
    color: white;
  }
  
  .ace_gutter-cell .ace_fold-widget {
    display: none !important;
  }
  
  .ace_cursor {
    color: $text-primary !important;
  }
  
  .ace_identifier {
    color: #1890ff;
  }

  .ace_numeric {
    color: #52c41a !important;
  }

  .ace_keyword {
    color: #722ed1 !important;
  }
  
  .ace_string {
    color: #fa8c16 !important;
  }
  
  .ace_comment {
    color: #8c8c8c !important;
    font-style: italic;
  }
  
  .ace_function {
    color: #13c2c2 !important;
  }
  
  .ace_variable {
    color: #eb2f96 !important;
  }
  
  .ace_constant {
    color: #faad14 !important;
  }
}
</style>
